var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 820.20001 572",
    width: 820.20001,
    height: 572,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#fff;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#040506;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_209",
    "data-name": "Grupo 209",
    transform: "translate(-265.55,-250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_333",
    "data-name": "Trazado 333",
    className: "cls-1",
    d: "m 385.2,663.87 h -69.06 v 5 c 5.06,1 16,4.1 11.56,14 L 265.55,822 h 32.84 l 19.45,-43.39 h 68.83 l 17,43.39 h 43.19 z M 326.65,759 354.58,696.78 379,759 Z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    "data-name": "Trazado 334",
    className: "cls-1",
    d: "m 590.06,663.87 h 31.17 L 555.34,822 H 510.51 L 455,681.8 a 21.76,21.76 0 0 0 -18,-12.95 v -5 h 58.57 l 46,116 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    "data-name": "Trazado 335",
    className: "cls-1",
    d: "m 643.81,663.87 h 57.42 V 822 H 659.56 V 681.8 c 0,-8.74 -12.32,-12.33 -15.69,-12.93 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    "data-name": "Trazado 336",
    className: "cls-1",
    d: "m 508,250 h 249.53 l -28.08,289.77 a 779.14,779.14 0 0 0 -221.36,54.3 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    "data-name": "Trazado 337",
    className: "cls-1",
    d: "m 853,250 v 283 q -34.54,0 -67.69,2.06 L 757.65,250 Z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_338",
    "data-name": "Trazado 338",
    className: "cls-1",
    d: "M 844.3,822 H 799.47 L 743.88,681.8 a 21.75,21.75 0 0 0 -17.82,-12.95 v -5 h 58.55 l 46,116 48.33,-116 h 31.16 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_339",
    "data-name": "Trazado 339",
    className: "cls-1",
    d: "m 1033.2,613.1 h -6.3 v -2.75 h 16.74 v 2.75 h -6.32 v 17.73 h -4.12 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_340",
    "data-name": "Trazado 340",
    className: "cls-1",
    d: "m 1051,630.83 h -3.32 v -20.48 h 5 c 2.11,5 5.52,13 6.3,15.69 v 0 c 1,-2.74 4.62,-10.65 7,-15.69 h 4.8 v 20.48 h -4.12 v -16 0 c -2.24,5.69 -4.6,10.85 -6.91,16 h -2.24 c -2.24,-5.13 -4.48,-10.29 -6.52,-16 v 0 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_341",
    "data-name": "Trazado 341",
    className: "cls-1",
    d: "M 1024.08,663.85 H 955 v 5 c 5,1 16,4.1 11.57,14 L 904.46,822 h 32.83 l 19.43,-43.39 h 68.84 l 17,43.39 h 43.19 z m -58.52,95.15 27.9,-62.22 24.41,62.22 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_342",
    "data-name": "Trazado 342",
    className: "cls-2",
    d: "m 1026.9,610.35 v 2.75 h 6.3 v 17.73 h 4.12 V 613.1 h 6.33 v -2.75 z m 39.25,0 c -2.35,5 -6,12.93 -7,15.69 v 0 c -0.79,-2.65 -4.19,-10.65 -6.3,-15.69 h -5.09 v 20.48 h 3.32 v -16 0 c 2.24,5.69 4.32,10.85 6.52,16 h 2.24 c 2.24,-5.13 4.64,-10.29 6.91,-16 v 0 16 h 4.12 v -20.48 z m -422.34,53.52 v 5 c 3.43,0.6 15.69,4.19 15.69,12.93 V 822 h 41.66 V 663.87 Z m -258.61,0 h -69.06 v 5 c 5.06,1 16,4.1 11.56,14 L 265.55,822 h 32.84 l 19.45,-43.39 h 68.83 l 17,43.39 h 43.19 z M 326.65,759 354.58,696.78 379,759 Z m 697.43,-95.12 H 955 v 5 c 5,1 16,4.1 11.57,14 L 904.46,822 h 32.83 l 19.43,-43.39 h 68.84 l 17,43.39 h 43.19 z M 965.56,759 993.46,696.78 1017.87,759 Z M 910.08,663.9 H 878.9 l -48.32,116 -46,-116 H 726 v 5 a 21.75,21.75 0 0 1 17.82,12.95 L 799.45,822 h 44.82 z m -288.84,0 h -31.18 l -48.35,116 -46,-116 h -58.56 v 5 a 21.76,21.76 0 0 1 17.93,12.95 L 510.62,822 h 44.83 z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_343",
    "data-name": "Trazado 343",
    className: "cls-2",
    d: "m 757.56,250 v 0 l 27.68,285 q 33.15,-1.95 67.69,-2.07 V 250 Z M 508,250 508.13,594.1 A 778.82,778.82 0 0 1 729.49,539.79 L 757.53,250 Z",
    style: {
      fill: "#040506",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviva);
export default __webpack_public_path__ + "static/media/aviva.56cfd3a3284dbf4af6fc99af4322de5b.svg";
export { ForwardRef as ReactComponent };